<template>
  <el-dialog :close-on-click-modal="false" :visible="viewVisible" :modal-append-to-body='false' @close="$emit('closeView')">
    <el-tabs v-model="viewName">
      <el-tab-pane label="电站详情" name="detailForm">
        <el-form :model="detailForm" ref="detailForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="基本信息" name="basicInformation">
              <el-col :span="12">
                <el-form-item label="场站编码：" :label-width="formLabelWidth" prop="stationCode">
                  <label v-text="detailForm.stationCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站名称：" :label-width="formLabelWidth" prop="stationName">
                  <label v-text="detailForm.stationName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站类型：" :label-width="formLabelWidth" prop="stationType">
                  <label v-if="detailForm.stationType" v-text="detailForm.stationType.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站状态：" :label-width="formLabelWidth" prop="stationStatus">
                  <label v-if="detailForm.stationStatus" v-text="detailForm.stationStatus.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="桩数量：" :label-width="formLabelWidth" prop="pileCount">
                  <label v-text="detailForm.pileCount"></label>
                </el-form-item>
              </el-col>
              <!--                  <el-col :span="12">-->
              <!--                    <el-form-item label="是否启用：" :label-width="formLabelWidth" prop="canUse">-->
              <!--                      <label v-if="detailForm.canUse" v-text="detailForm.canUse.message"></label>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <el-col :span="12">
                <el-form-item label="费率组：" :label-width="formLabelWidth" prop="serviceBillingRulesName">
                  <label v-text="detailForm.serviceBillingRulesName"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorName">
                  <label v-text="detailForm.operatorName"></label>
                </el-form-item>
              </el-col>
              <!--<el-col :span="12">
                <el-form-item label="二级运营商：" :label-width="formLabelWidth" prop="virtualId">
                  <label v-text="detailForm.virtualId"></label>
                </el-form-item>
              </el-col>-->
              <el-col :span="12">
                <el-form-item label="场站面积：" :label-width="formLabelWidth" prop="siteArea">
                  <label v-text="detailForm.siteArea"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地区类型：" :label-width="formLabelWidth" prop="addressType">
                  <label v-if="detailForm.addressType" v-text="detailForm.addressType.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="互联互通：" :label-width="formLabelWidth" prop="isCec">
                  <label v-if="detailForm.isCec" v-text="detailForm.isCec.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="快慢充：" :label-width="formLabelWidth" prop="fastOrSlow">
                  <label v-if="detailForm.fastOrSlow" v-text="detailForm.fastOrSlow.message+'站'"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="位置信息" name="addressInformation">
              <el-col :span="12">
                <el-form-item label="省：" :label-width="formLabelWidth" prop="province">
                  <label v-text="detailForm.province"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="市：" :label-width="formLabelWidth" prop="city">
                  <label v-text="detailForm.city"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="区：" :label-width="formLabelWidth" prop="area">
                  <label v-text="detailForm.area"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="细详地址：" :label-width="formLabelWidth" prop="address">
                  <label v-text="detailForm.address"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="经度：" :label-width="formLabelWidth" prop="longitude">
                  <label v-text="detailForm.longitude"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纬度：" :label-width="formLabelWidth" prop="latitude">
                  <label v-text="detailForm.latitude"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="运营信息" name="operationalInformation">
              <el-col :span="12">
                <el-form-item label="负责人：" :label-width="formLabelWidth" prop="dutyPerson">
                  <label v-text="detailForm.dutyPerson"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人手机号：" :label-width="formLabelWidth" prop="dutyPersonPhone">
                  <label v-text="detailForm.dutyPersonPhone"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运营管理费/元：" :label-width="formLabelWidth" prop="managementPrice">
                  <label v-text="detailForm.managementPrice"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="营业时间：" :label-width="formLabelWidth" prop="businessHours">
                  <label v-text="detailForm.businessHours"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="营业类型：" :label-width="formLabelWidth" prop="businessType">
                  <label v-if="detailForm.businessType" v-text="detailForm.businessType.message"></label>
                </el-form-item>
              </el-col>
              <!--                  <el-col :span="12">-->
              <!--                    <el-form-item label="停车场管理单位：" :label-width="formLabelWidth" prop="parkingLotOwner">-->
              <!--                      <label v-text="detailForm.parkingLotOwner"></label>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <el-col :span="12">
                <el-form-item label="停车场开放时间：" :label-width="formLabelWidth" prop="parkingLotOpenHours">
                  <label v-text="detailForm.parkingLotOpenHours"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="停车位数量：" :label-width="formLabelWidth" prop="parkNum">
                  <label v-text="detailForm.parkNum"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否收取停车费：" :label-width="formLabelWidth" prop="isParkingFee">
                  <label v-if="detailForm.isParkingFee" v-text="detailForm.isParkingFee.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="停车场费用：" :label-width="formLabelWidth" prop="parkingLotFee">
                  <label v-text="detailForm.parkingLotFee"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否启用占桩计费：" :label-width="formLabelWidth" prop="feesTakeUpPile">
                  <label v-if="detailForm.feesTakeUpPile" v-text="detailForm.feesTakeUpPile.message"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="占桩计费时长/分钟：" :label-width="formLabelWidth" prop="takeUpTime">
                  <label v-text="detailForm.takeUpTime"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="占桩单价/分钟：" :label-width="formLabelWidth" prop="takeUpPrice">
                  <label v-text="detailForm.takeUpPrice"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="佣金开启充电：" :label-width="formLabelWidth" prop="commissionChargeFlag">
                  <label v-if="detailForm.commissionChargeFlag"
                         v-text="detailForm.commissionChargeFlag.message"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <!--                <el-collapse-item title="图片信息" name="pictureInformation">-->
            <!--                  <el-col :span="12">-->
            <!--                    <el-form-item label="站点附近照片：" :label-width="formLabelWidth" prop="picture">-->
            <!--&lt;!&ndash;                      <label v-text="detailForm.picture"></label>&ndash;&gt;-->
            <!--                    </el-form-item>-->
            <!--                  </el-col>-->
            <!--                  <el-col :span="12">-->
            <!--                    <el-form-item label="场站标志：" :label-width="formLabelWidth" prop="logo">-->
            <!--&lt;!&ndash;                      <label v-text="detailForm.logo"></label>&ndash;&gt;-->
            <!--                    </el-form-item>-->
            <!--                  </el-col>-->
            <!--                </el-collapse-item>-->
            <el-collapse-item title="互联互通其他信息" name="interconnectingOtherInformation">
              <el-col :span="12">
                <el-form-item label="设备所属方id：" :label-width="formLabelWidth" prop="equipmentOwnerID">
                  <label v-text="detailForm.equipmentOwnerID"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="充电站国家代码：" :label-width="formLabelWidth" prop="countryCode">
                  <label v-text="detailForm.countryCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地区代码：" :label-width="formLabelWidth" prop="areaCode">
                  <label v-text="detailForm.areaCode"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="站点电话：" :label-width="formLabelWidth" prop="stationTel">
                  <label v-text="detailForm.stationTel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务电话：" :label-width="formLabelWidth" prop="serviceTel">
                  <label v-text="detailForm.serviceTel"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="站点引导：" :label-width="formLabelWidth" prop="siteGuide">
                  <label v-text="detailForm.siteGuide"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="使用车型描述：" :label-width="formLabelWidth" prop="matchCars">
                  <label v-text="detailForm.matchCars"></label>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车位楼层及数量描述：" :label-width="formLabelWidth" prop="parkInfo">
                  <label v-text="detailForm.parkInfo"></label>
                </el-form-item>
              </el-col>
              <!--                  <el-col :span="12">-->
              <!--                    <el-form-item label="支付方式：" :label-width="formLabelWidth" prop="payment">-->
              <!--                      <label v-text="detailForm.payment"></label>-->
              <!--                    </el-form-item>-->
              <!--                  </el-col>-->
              <el-col :span="12">
                <el-form-item label="是否支持预约：" :label-width="formLabelWidth" prop="supportOrder">
                  <label v-if="detailForm.supportOrder" v-text="detailForm.supportOrder.message"></label>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="标签管理" name="searchTabsAddForm" v-if="checkPermission(['bee:res:station:editSearchTabs'])">
        <el-form :model="searchTabsAddForm" ref="searchTabsAddForm" size="mini" style="height: 400px" class="searchTabsAddForm">
          <el-tag
            :key="tag"
            v-for="tag in searchTabsAddForm.searchTabs"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
            <el-input
              class="input-new-tag"
              v-model="inputValue"
              v-if="inputVisible"
              ref="saveTagInput"
              size="small"
              clearable
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加</el-button>
        </el-form>
        <el-button size="mini" plain @click="$emit('closeView')">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="confirmSearchTabsAddForm"
                   v-if="checkPermission(['bee:res:station:editSearchTabs'])">提交
        </el-button>
      </el-tab-pane>
      <el-tab-pane label="绑定/解绑费率" name="bindingRateForm" v-if="checkPermission(['bee:res:station:bindingRate'])">
        <el-form :model="bindingRateForm" ref="bindingRateForm" size="mini" style="height: 400px" class="bindingRateForm" :rules="bindingRateFormRules">
          <div v-if="bindingRateForm.serviceBillingRulesId">
            <el-col :span="24">
              <el-form-item label="费率："  prop="ruleName">
                <label>{{bindingRateForm.ruleName}}</label>
                <el-button size="mini" plain style="margin-left: 10px" @click="unbinding">解绑</el-button>
              </el-form-item>
            </el-col>
          </div>
          <div v-else>
            <el-col :span="24">
              <el-form-item label="费率：" :label-width="formLabelWidth" prop="serviceBillingRulesIdTemp">
                <el-select autocomplete="off" v-model="bindingRateForm.serviceBillingRulesIdTemp">
                  <el-option v-for="item in serviceBillingRulesSelect" :key="item.id"
                             v-bind:label="item.ruleName" v-bind:value="item.id"></el-option>
                </el-select>
                <el-button size="mini" plain style="margin-left: 10px" @click="dobinding">绑定</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="上传电站头像" name="uploadAvatar" v-if="checkPermission(['bee:res:station:saveStationImg'])">
        <el-form :model="uploadAvatarForm" ref="uploadAvatarForm" size="mini" style="height: 400px" class="uploadAvatarForm">
          <el-upload
            action="#"
            list-type="picture-card"
            :auto-upload="true"
            :multiple="false"
            :limit="1"

            :on-change="uploadAvatarFormChange"
            :on-remove="uploadAvatarFormRemove"
            :before-upload="uploadAvatarFormBeforeUpload"
            :on-success="uploadAvatarFormUpload"
            :http-request="uploadAvatarFormRequest"
            :file-list="uploadAvatarFormFileList"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.src" alt=""
              >
              <span class="el-upload-list__item-actions">
                  </span>
            </div>
            <div slot="tip" class="el-upload__tip">图片尺寸为300x300显示效果最佳</div>
          </el-upload>
          <el-dialog :visible.sync="uploadAvatarFormDialogVisible" :modal-append-to-body='false'>
            <img width="100%" :src="uploadAvatarFormDialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <el-button size="mini" plain @click="$emit('closeView')">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="confirmUploadAvatarForm">提交
        </el-button>
      </el-tab-pane>
      <!--:on-preview="uploadSitePicFormPictureCardPreview"-->
      <!--<el-tab-pane label="上传站点引导图" name="uploadSitePic">
        <el-form :model="uploadSitePicForm" ref="uploadSitePicForm" size="mini" class="uploadSitePicForm">
          <el-upload
            action="#"
            list-type="picture-card"
            :auto-upload="true"
            :multiple="false"
            :limit="3"

            :on-change="uploadSitePicFormChange"
            :on-remove="uploadSitePicFormRemove"
            :before-upload="uploadSitePicFormBeforeUpload"
            :on-success="uploadSitePicFormUpload"
            :http-request="uploadSitePicFormRequest"
            :file-list="uploadSitePicFormFileList"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.src" alt=""
              >
              <span class="el-upload-list__item-actions">
                  </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="uploadSitePicFormDialogVisible" :modal-append-to-body='false'>
            <img width="100%" :src="uploadSitePicFormDialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <el-button size="mini" plain @click="$emit('closeView')">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="confirmUploadSitePicForm">提交</el-button>
      </el-tab-pane>-->

      <el-tab-pane label="上传站点引导图" name="newUploadSitePictures" v-if="checkPermission(['bee:res:station:uploadStationGuideImage'])">
        <el-form :model="newUploadSitePicturesForm" ref="newUploadSitePicturesForm" size="mini" style="height: 400px" class="uploadSitePicForm">
          <el-upload
            :action="uploadImage()"
            :on-preview="stationHandlePictureCardPreview"
            :on-remove="stationHandleRemove"
            :before-upload="uploadSitePicFormBeforeUpload"
            :on-success="stationUploadSuccess"
            :on-error="stationUploadError"
            :on-exceed="stationExceed"
            :limit="10"
            :file-list="newUploadSitePicturesList"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="stationDialogVisible">
            <img width="100%" :src="stationDialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <el-button size="mini" plain @click="viewVisible = false">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="stationUploadImage">提交</el-button>
      </el-tab-pane>

      <!--生成桩枪数据-->
      <el-tab-pane label="快速创建电桩和电枪" name="createPileAndGunForm" v-if="checkPermission(['bee:res:station:createPileAndGun'])">
        <el-form v-loading="loading" :model="createPileAndGunForm" ref="createPileAndGunForm" size="mini" style="height: 400px" class="uploadSitePicForm" :rules="createPileAndGunRules">
          <el-col :span="24">
            <el-form-item label="充电站名称：" :label-width="formLabelWidth" prop="stationName">
              <el-input v-model="createPileAndGunForm.stationName" autocomplete="off" readonly="readonly"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="充电桩软件协议：" :label-width="formLabelWidth" prop="protocol">
              <el-select placeholder="请选择" v-model="createPileAndGunForm.protocol">
                <el-option v-for="item in protocolEnumData" :key="item.value"
                           v-bind:label="item.message" v-bind:value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="充电桩型号：" :label-width="formLabelWidth" prop="pileModel">
              <el-select placeholder="请选择" v-model="createPileAndGunForm.pileModel">
                <el-option v-for="item in pileModelEnumData" :key="item.id"
                           v-bind:label="item.typeModel + '(' + item.typeName + ')'" v-bind:value="item.id"></el-option>
              </el-select>
              <span style="color:#F56C6C">*注：优利特的桩请手动添加</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否共享桩：" :label-width="formLabelWidth" prop="isShare">
              <el-select placeholder="请选择" v-model="createPileAndGunForm.isShare">
                <el-option v-for="item in YesNoEnumData" :key="item.value"
                           v-bind:label="item.message" v-bind:value="item.value"></el-option>
              </el-select>
              <span style="color:#F56C6C">*注：默认不共享</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="单枪桩总数量：" :label-width="formLabelWidth" prop="oneGunNum">
              <el-input v-model="createPileAndGunForm.oneGunNum" autocomplete="off"></el-input>
              <span style="color:#F56C6C">*所选型号为单枪时，编辑该选项数量，下列双枪数量为0</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="双枪桩总数量：" :label-width="formLabelWidth" prop="secondGunNum">
              <el-input v-model="createPileAndGunForm.secondGunNum" autocomplete="off"></el-input>
              <span style="color:#F56C6C">*所选型号为双枪时，编辑该选项数量，上列单枪数量为0</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="三枪桩总数量：" :label-width="formLabelWidth" prop="threeGunNum">
              <el-input disabled v-model="createPileAndGunForm.threeGunNum" autocomplete="off"></el-input>

            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="四枪桩总数量：" :label-width="formLabelWidth" prop="fourGunNum">
              <el-input disabled v-model="createPileAndGunForm.fourGunNum" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <el-button size="mini" plain @click="viewVisible = false">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="createPileAndGunMethod">提交</el-button>
        <el-button size="mini" plain @click="addDevice">或手动添加</el-button>

      </el-tab-pane>


    </el-tabs>
  </el-dialog>
</template>

<script>
  import stationApi from '../../api/stationApi'
  import {validateInput} from '../../../../common/validator'
  import rules from "../../../memberCenter/common/rules";
  import sysConfig from '@/../config/sysConfig'
  import service from '@/../config/serviceList'
  export default {
    name: "customizeView",
    data(){
      return{
        viewName: 'detailForm',
        bindingRateFormRules:{
          serviceBillingRulesIdTemp:[{required: true, message: '请选择费率', trigger: 'blur'}]
        },
        activeNames: ['basicInformation', 'addressInformation'],
        formLabelWidth: '155px',
        inputVisible: false,
        inputValue: '',
        isUploadLogo:false,
        isUploadPicture:false,
        uploadAvatarFormDialogImageUrl: '',
        uploadAvatarFormDialogVisible: false,
        uploadSitePicFormDialogImageUrl: '',
        uploadSitePicFormDialogVisible: false,
        stationDialogVisible:false,
        stationDialogImageUrl:'',
        serviceBillingRulesIdTemp: '',
        createPileAndGunRules:{
          protocol: [{required: true, message: '请选择充电桩软件协议', trigger: 'blur'}],
          pileModel: [{required: true, message: '请选择充电桩型号', trigger: 'blur'}],
          isShare: [{required: true, message: '请选择是否共享', trigger: 'blur'}],
          oneGunNum: [{required: true, message: '请输入此站单枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
            }, trigger: 'blur'}],
          secondGunNum: [{required: true, message: '请输入此站双枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
            }, trigger: 'blur'}],
          threeGunNum: [{required: true, message: '请输入此站三枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
            }, trigger: 'blur'}],
          fourGunNum: [{required: true, message: '请输入此站四枪口充电桩总数量', trigger: 'blur'},{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,6,true,true,true,true,false,false,false)
            }, trigger: 'blur'}],
        },

        loading:false
      }
    },
    props:{
      viewVisible:{
        type:Boolean,
        required: true
      },
      detailForm: {},
      searchTabsAddForm: {
        searchTabs: []
      },
      bindingRateForm: {},
      serviceBillingRulesSelect:{},
      uploadAvatarForm: {},
      uploadSitePicForm: {},
      stationUploadImageForm:{},
      newUploadSitePicturesForm:{},
      uploadAvatarFormFileList: {
        type:Array
      },
      uploadSitePicFormFileList: {
        type:Array
      },
      newUploadSitePicturesList:{
        type:Array
      },
      stationImageUrlList:{
        type:Array
      },
      createPileAndGunForm:{},
      protocolEnumData:'',
      pileModelEnumData:'',
      YesNoEnumData: ''
    },
    methods:{
      addDevice(){
        this.$router.push( '/resourceCenter/deviceManager')
      },

      /*-------------图片上传 by chenyanhui----------------*/
      stationHandleRemove(file, fileList) {
        console.log(file);
        console.log(this.stationImageUrlList);
        this.stationImageUrlList.splice(this.stationImageUrlList.findIndex(item => item === file.name), 1);
        console.log(this.stationImageUrlList);
      },
      stationHandlePictureCardPreview(file) {
        this.stationDialogImageUrl = file.url;
        this.stationDialogVisible = true;
      },
      uploadImage() {
        return sysConfig.apiPre + service.ops + "/ops/upload/image_upload";
      },
      stationUploadSuccess(response,file,fileList){
        console.log(response);
        if(response.code===0){
          console.log(response.data);
          file.name=response.data;
          this.stationImageUrlList.push(response.data);
        }else{
          this.$message({
            type: 'error',
            message: "文件上传失败，请稍后重试"
          });
        }
      },
      stationUploadError(err,file,fileList){
        console.log(err);
        this.$message({
          type: 'error',
          message: "文件上传失败，请稍后重试"
        });
      },
      stationExceed(file,fileList){
        this.$message({
          type: 'info',
          message: "最多只能上传10张图片"
        });
      },
      stationUploadImage(){
        console.log(this.stationImageUrlList);
        this.newUploadSitePicturesForm.images=this.stationImageUrlList;
        stationApi.uploadStationImg(this.newUploadSitePicturesForm).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.$emit("closeView")
            this.$emit('submitStationSearchForm')
            this.$emit('revertStationPicturesFormFileList')
          } else {
            this.$message.error(res.message)
          }
        })
      },
      /*-----------------------------------*/
      createPileAndGunMethod() {
        this.$refs["createPileAndGunForm"].validate((valid) => {

          if (!valid) {
            return;
          } else {
            this.$confirm('确定要生成桩和枪吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                let param = Object.assign({}, this.createPileAndGunForm)
                console.log("参数:"+JSON.stringify(this.createPileAndGunForm));
                this.loading = true;
                stationApi.createPileAndGun(param).then((res)=>{
                  this.loading = false;
                  this.$message({
                    type: 'info',
                    message: res.data
                  });
                  this.viewVisible =false;
                }).catch(() => {
                  this.loading = false;
                })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消操作！'
                })
              })
          }
        })
      },
      // 添加标签
      handleClose(tag) {
        this.searchTabsAddForm.searchTabs.splice(this.searchTabsAddForm.searchTabs.indexOf(tag), 1)// 删除按钮
      },

      handleInputConfirm() {
          let inputValue = this.inputValue
          if (inputValue) {
            if (inputValue.length>4){
              this.$message.error("请不要输入超过8个字")
              return
            }
            if (this.searchTabsAddForm.searchTabs.length>10){
              this.$message.error("请不要添加超过10个标签")
              this.inputVisible = false
              this.inputValue = ''
              return
            }
            this.searchTabsAddForm.searchTabs.push(inputValue)// 添加按钮
          }
          this.inputVisible = false
          this.inputValue = ''
      },
      showInput() {
        this.inputVisible = true
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      },
      confirmSearchTabsAddForm() {
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          let param = JSON.stringify(this.searchTabsAddForm)
          stationApi.editSearchTabs(param).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.$emit('closeView')
              this.$emit('submitStationSearchForm')
            } else {
              this.$message.error(res.message)
            }
          })
        })
      },
      unbinding(){
        this.$emit("unbinding")
      },
      dobinding(){
        this.$emit("dobinding",this.$refs["bindingRateForm"])
      },
	  // 约定上传格式
      compression(file){
        //只能上传图片格式
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');

        }
        if (!isJPG) {
          this.$message.error('上传头像图片只能是jpg/png格式!');
        }
        return isLt2M && isJPG;
      },
      uploadAvatarFormPictureCardPreview(file) {
        this.uploadAvatarFormDialogImageUrl = file.url;
        this.uploadAvatarFormDialogVisible = true;
      },
      uploadAvatarFormChange(file, fileList){
        this.isUploadLogo = true;
      },
      uploadAvatarFormRemove(file) {
        this.uploadAvatarForm.logo = "";
        this.isUploadLogo = true;
      },
      uploadAvatarFormBeforeUpload(file){
        if(!this.compression(file)){
          this.$emit('revertUploadAvatarFormFileList');
          this.uploadAvatarForm.logo =""
        }
      },
      uploadAvatarFormUpload(file) {
      },
      uploadAvatarFormRequest(file){
        // let self = this
        this.uploadAvatarForm.logo = file.file
        // this.uploadFile(file.file).then(function(result){
        //   //处理 result})
        //   self.uploadAvatarForm.logo = file.file
        // })
      },
	  // 上传头像提交
      confirmUploadAvatarForm(){
        if(this.isUploadLogo===true){
          let param = new FormData();
          param.append("id",this.uploadAvatarForm.id);
          if(this.uploadAvatarForm.logo !== "" && this.uploadAvatarForm.logo !== null){
            param.append("logo",this.uploadAvatarForm.logo);
          }
          param.append("type","logo");
		  console.log(9900000)
		  console.log(param)
          stationApi.saveStationImg(param).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.$emit("closeView")
              this.$emit('submitStationSearchForm')
              this.$emit('revertUploadAvatarFormFileList')
            } else {
              this.$message.error(res.message)
            }
          })
        }else{
          this.$message({
            message: '未修改图片，无需提交',
            type: 'info'
          })
        }
      },
      uploadSitePicFormPictureCardPreview(file) {
        this.uploadSitePicFormDialogImageUrl = file.url;
        this.uploadSitePicFormDialogVisible = true;
      },
      uploadSitePicFormChange(file, fileList){
        this.isUploadPicture = true;
      },
      uploadSitePicFormRemove(file) {
        //this.uploadSitePicForm.picture.splice(file.url,1)
        this.uploadSitePicFormFileList=[];
        this.uploadSitePicForm.picture=[];
        this.isUploadPicture = true;
      },
      uploadSitePicFormBeforeUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M
      },
      uploadSitePicFormUpload(file) {
      },
      uploadSitePicFormRequest(file){
        // let self = this
        // this.uploadSitePicForm.picture.push(file.file)
        this.uploadSitePicForm.picture = [...this.uploadSitePicForm.picture, file.file]
        // this.uploadFile(file.file).then(function(result){
        //   self.uploadSitePicForm.picture.push(result)
        // })
      },
      confirmUploadSitePicForm(){
        if(this.isUploadPicture===true){
          let param = new FormData();
          console.log(this.uploadSitePicForm)
          this.uploadSitePicForm.picture.forEach(function (file) {
            param.append('picture', file, file.name); // 因为要上传多个文件，所以需要遍历一下才行
            // 不要直接使用我们的文件数组进行上传，你会发现传给后台的是两个Object
          })
          param.append("id",this.uploadSitePicForm.id)
          param.append("type","stationImg");
          stationApi.saveStationImg(param).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.$emit("closeView");
              this.$emit('submitStationSearchForm')
              this.$emit('revertUploadSitePicFormFileList')
            } else {
              this.$message.error(res.message)
            }
          })
        }else{
          this.$message({
            message: '未修改图片，无需提交',
            type: 'info'
          })
        }
      },
    }
  }
</script>

<style scoped lang="less">
  /deep/ .detail_form, /deep/ .searchTabsAddForm, /deep/ .bindingRateForm, /deep/ .uploadAvatarForm, /deep/ .uploadSitePicForm
  {
    height: 550px;
    overflow: auto;

  .el-form-item__label {
    color: rgba(0, 0, 0, 0.47);
  }
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-right: 10px;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
    margin-top: 10px;
    margin-right: 10px;
  }

  .searchTabsAddForm,.uploadAvatarForm,.uploadSitePicForm,.bindingRateForm {
    text-align: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/customizeView.vue